
    import I18n from 'i18nObj';
    
      import 'translations/keyboard_nav_dialog';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('keyboard_nav_dialog');
  